import React from "react";
import PropTypes from "prop-types";
import { InputAdornment, TextField, useTheme } from "@mui/material";

// const appcolors = {
//   slateGrey: "#708090", // Replace with your actual color value
// };

function TextInput({
  InputStartIcon,
  InputEndIcon,
  fullWidth,
  readonly,
  defaultStyle,
  value,
  onChange,
  style,
  disabled,
  ...props
}) {
  const { palette } = useTheme();

  //   const useStyle = {
  //     "& .MuiOutlinedInput-root": {
  //       borderRadius: "6px",
  //       "& .MuiOutlinedInput-input": {
  //         padding: "12px 16px",
  //       },
  //       "& .MuiOutlinedInput-notchedOutline": {
  //         border: `1px solid ${palette.text.coolGrey}`,
  //       },
  //       "&:hover .MuiOutlinedInput-notchedOutline": {
  //         border: `1px solid ${palette.text.coolGrey} !important`,
  //       },
  //       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
  //         border: `1px solid ${palette.text.coolGrey} !important`,
  //       },
  //     },
  //     "& .Mui-error": {
  //       "& .MuiOutlinedInput-notchedOutline": {
  //         border: `1px solid #d32f2f !important`,
  //       },
  //       "&:hover .MuiOutlinedInput-notchedOutline": {
  //         border: `1px solid #d32f2f !important`,
  //       },
  //     },
  //     "& .MuiFormHelperText-root": {
  //       marginLeft: 0,
  //       marginTop: 0,
  //     },
  //     "& .Mui-disabled": {
  //       cursor: "not-allowed",
  //     },
  //   };

  return (
    <TextField
      fullWidth={fullWidth}
      disabled={disabled}
      value={value}
      onChange={onChange}
      {...props}
      InputProps={{
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment position="end" sx={{ cursor: "pointer" }}>
            {InputEndIcon}
          </InputAdornment>
        ),
      }}
      //   sx={defaultStyle ? useStyle : style}
    />
  );
}

TextInput.propTypes = {
  InputStartIcon: PropTypes.element,
  InputEndIcon: PropTypes.element,
  fullWidth: PropTypes.bool,
  readonly: PropTypes.bool,
};

TextInput.defaultProps = {
  fullWidth: true,
  readonly: false,
};

export default TextInput;
